export const environment = {
  production: false,
  apiUrl: 'https://dev.thehuskbakery.com'
};
